import React, { useState, useEffect, forwardRef/*, useImperativeHandle*/ } from "react";
import ttAPI from '../../api/ttAPI';
import { Link } from '../../components/Wrappers'
import { Grid, TableRow, TableCell, CircularProgress, Avatar, Tooltip,
         IconButton, TableFooter, FormControlLabel, Switch, Button } from "@material-ui/core";
import MUIDataTable, {ExpandButton} from "mui-datatables";
import { useHistory } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import classnames from "classnames";

// components
import Widget from "../../components/Widget";
import config from '../../config'
import MultiSelectAutoComplete from '../MultiSelectAutoComplete/MultiSelectAutoComplete';

// Icons
import {
    CloudDownload as CloudDownloadIcon,
    Description as DescriptionIcon,
    Layers as LayersIcon
} from '@material-ui/icons';

import MultiSiteEstimateDialog from './MultiSiteEstimateDialog';
import CustomerNotesReviewDialog from './CustomerNotesReviewDialog';

import useStyles from './styles';
import './SiteRetests.css';

const SiteRetests = forwardRef((props, ref) => {
  // global
  const { onCopyExpiry, onRemoveExpiry, onCopyAllExpiry, onRemoveAllExpiry, onShowCopyExpiryButton, onAddTotalSelectedToInstructions } = props
  const classes = useStyles();

  // local
  var [data, setData] = useState([]);
  /*var [rowsExpanded, setRowsExpanded] = useState([]);
  var isCopyClicked = false;*/
  var [totalAssetsSelected, setTotalAssetsSelected] = useState(0);
  var [totalAssets, setTotalAssets] = useState(0);
  const [lastSiteVisit, setLastSiteVisit] = useState('');
  const [isRowsSelectedDone, setIsRowsSelectedDone] = useState(false);
  const [preRowsSelected, setPreRowsSelected] = useState([]);
  const [curRowsSelected, setCurRowsSelected] = useState([]);
  const [fontSize, setFontSize] = useState(0.875);
  const [detailedTagCountStyle, setDetailedTagCountStyle] = useState('17% 5% 78%');
  var [selectedTagTypes, setSelectedTagTypes] = useState([]);
  const [isAllTagTypes, setIsAllTagTypes] = useState(true);
  const [openMultiSiteEstimate, setOpenMultiSiteEstimate] = useState(false);
  const [openCustomerNotesReview, setOpenCustomerNotesReview] = useState(false);
  const [tagTypesOptions, setTagTypesOptions] = useState([
                           {type_name:'1 Phase',type_value:'1ph'},
                           {type_name:'3 Phase/LG/RCD',type_value:'3ph-lg-rcd'},
                           {type_name:'AED',type_value:'aed'},
                           {type_name:'EVSE',type_value:'evse'},
                           {type_name:'Fire Extinguishers',type_value:'fe'},
                           {type_name:'Fire Blankets',type_value:'fb'},
                           {type_name:'Fire Hose Reels',type_value:'fh'},
                           {type_name:'First Aid',type_value:'fa'},
                           {type_name:'Medical',type_value:'med'},
                           {type_name:'Microwave',type_value:'mw'}]);
  const [assetCoverageYearMonth, setAssetCoverageYearMonth] = useState(null);



  const getMuiTheme = () => createMuiTheme({
    palette: { primary: { main: '#FFCA06' } },
    overrides: {
      MUIDataTableToolbar: {
        root: {
          minHeight: '48px',
          height: '48px',
          padding: 0,
          visibility: 'hidden'
        }
      },
      MUIDataTableToolbarSelect: {
        root: {
          minHeight: '48px',
          height: '48px',
          padding: 0
        }
      },
      MUIDataTable: { root: { padding: 0 } },
      MUIDataTableBodyRow: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04) !important'
          }
        }
      },
      MuiTableCell: { root: { padding: '0px' } },
    }
  });

   const commonSetCellProps = (data, lastSiteVisit) => (cellValue, rowIndex, columnIndex) => {
       if (new Date(data[rowIndex].expiry) <= new Date(lastSiteVisit)) {
         return {
           style: { textDecoration: 'line-through' },
         };
       }

       return {
         style: { textDecoration: 'none' },
       };
     };

   const createHeaderWithTooltip = (title, tooltip, wrap) => (columnMeta) => {
     return (
       <Tooltip title={tooltip} placement='top'>
         <span style={{ textAlign: 'center', padding: '0 2px', fontSize: `${fontSize}rem`}} className={classnames({
             [classes.wrapColTitle]: wrap === null ? false : wrap,
           })}>{title}</span>
       </Tooltip>
     );
   };

   /*const onClickFireExtinguisherCount = (tableMeta) => {
          window.open(
          `${config.clientApi}/dashboard/site_assets?id=${props.site_id}&month_expiry=${tableMeta.rowData[0]}&fire_extinguishers_only=true`,
          '_blank'
          );

   };*/

   const onClickTagCount = (tableMeta) => {
          window.open(
          `${config.clientApi}/dashboard/site_assets?id=${props.site_id}&month_expiry=${tableMeta.rowData[0]}&types=${tableMeta.columnData.name}`,
          '_blank'
          );

   };


  const columns = [
    { label: 'Expiry', name: 'expiry',
      options: {filter: false,
                display: true,
                download: true,
                sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customBodyRender: (value, tableMeta) => {
                  return (<div style={{textAlign: 'center'}}>{tableMeta.rowData[0]}</div>);
                }}},
    { label: '#Assets', name: 'assets',
      options: {filter: false,
                display: true,
                download: true,
                sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customBodyRender: (value, tableMeta) => {
                  return (<div style={{textAlign: 'center'}}>{tableMeta.rowData[1]}</div>);
                }}},
    { label: 'Test Period', name: 'validity',
      options: {filter: false,
                display: true,
                download: true,
                sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customBodyRender: (value, tableMeta) => {
                  return (<div style={{minWidth: '40px', textAlign: 'center'}}>{tableMeta.rowData[2]}</div>);
                },
                customHeadLabelRender: createHeaderWithTooltip('Test Period', 'Test Period / Validity (in Months)', true)}},
    { label: '1PH', name: 'one_phase_count',
      options: {filter: false, download: true, display: false, sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customHeadLabelRender: createHeaderWithTooltip('1PH', '1 Phase')}},
    { label: '3PH', name: 'three_phase_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'RCD M', name: 'rcd_m_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'RCD PB', name: 'rcd_pb_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'LG M', name: 'lg_m_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'LG PB', name: 'lg_pb_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: '3PH RCD', name: 'three_phase_rcd_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'Microwave', name: 'microwave_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'Microwave LKG', name: 'microwave_leakage_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'FE', name: 'fe',
      options: {
        filter: false,
        download: true,
        display: true,
        sort: false,
        setCellProps: commonSetCellProps(data, lastSiteVisit),
        customBodyRender: (value, tableMeta) => {
          const feCount = tableMeta.rowData[12];
          const feReplacementRequired = tableMeta.rowData[43];

          return feCount ? (
            <Tooltip title={`Download Fire Extinguisher CSV for ${tableMeta.rowData[0]}`}>
              <div
                onClick={() => onClickTagCount(tableMeta)}
                className={classes.tagSingleRowDownload}
                style={{
                  color: feReplacementRequired > 0 ? '#d32f2f' : undefined,
                  fontWeight: feReplacementRequired > 0 ? 600 : 400
                }}
              >
                {feCount}
              </div>
            </Tooltip>
          ) : (
            <div className={classes.tagSingleRowNoDownload}>{feCount}</div>
          );
        },
        customHeadLabelRender: createHeaderWithTooltip('FE', 'Fire Extinguisher')
      }
    },
    { label: 'Fire Blankets', name: 'fire_blankets', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'Fire Hose Reels', name: 'fire_hose_reels', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'Smoke Alarm', name: 'smoke_alarm', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'FA', name: 'fa',
      options: {filter: false, download: true, display: true, sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customHeadLabelRender: createHeaderWithTooltip('FA', 'First Aid'),
                customBodyRender: (value, tableMeta) => {
                  return (tableMeta.rowData[16] ?
                    (<Tooltip title={`Download First Aid CSV for ${tableMeta.rowData[0]}`}>
                            <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}>
                              {tableMeta.rowData[16]}
                            </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[16]}</div>));
                }}},
    { label: 'Med', name: 'med',
      options: {filter: false, download: true, display: true, sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customHeadLabelRender: createHeaderWithTooltip('MED', 'Medical'),
                customBodyRender: (value, tableMeta) => {
                  return (tableMeta.rowData[17] ?
                    (<Tooltip title={`Download Medical CSV for ${tableMeta.rowData[0]}`}>
                            <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}>
                              {tableMeta.rowData[17]}
                            </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[17]}</div>));
                }}},
    { label: 'EVSE', name: 'evse',
      options: {filter: false, download: true, display: true, sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customHeadLabelRender: createHeaderWithTooltip('EVSE', 'Electrical Vehicle and Supplied Equipment'),
                customBodyRender: (value, tableMeta) => {
                  return (tableMeta.rowData[18] ?
                    (<Tooltip title={`Download EVSE CSV for ${tableMeta.rowData[0]}`}>
                            <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}>
                              {tableMeta.rowData[18]}
                            </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[18]}</div>));
                }}},
    { label: 'AED', name: 'aed',
      options: {filter: false, download: true, display: true, sort: false,
                setCellProps: commonSetCellProps(data, lastSiteVisit),
                customBodyRender: (value, tableMeta) => {
                  return (tableMeta.rowData[19] ?
                    (<Tooltip title={`Download AED CSV for ${tableMeta.rowData[0]}`}>
                            <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}>
                              {tableMeta.rowData[19]}
                            </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[19]}</div>));
                }}},
    { label: 'Ladder', name: 'ladder_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'Other', name: 'other_count', options: {filter: false, download: true, display: false, sort: false}},
    { label: 'LG/RCD/3PH', name: '3ph-lg-rcd',
      options: {
        filter: false,
        download: false,
        display: true,
        sort: false,
        setCellProps: commonSetCellProps(data, lastSiteVisit),
        customBodyRender: (value, tableMeta) => {
          const total =
            tableMeta.rowData[4] +
            tableMeta.rowData[5] +
            tableMeta.rowData[6] +
            tableMeta.rowData[7] +
            tableMeta.rowData[8] +
            tableMeta.rowData[9];
          return (tableMeta.rowData[4] !== undefined && tableMeta.rowData[4] !== null &&
                  tableMeta.rowData[5] !== undefined && tableMeta.rowData[5] !== null &&
                  tableMeta.rowData[6] !== undefined && tableMeta.rowData[6] !== null &&
                  tableMeta.rowData[7] !== undefined && tableMeta.rowData[7] !== null &&
                  tableMeta.rowData[8] !== undefined && tableMeta.rowData[8] !== null &&
                  tableMeta.rowData[9] !== undefined && tableMeta.rowData[9] !== null &&
                  (tableMeta.rowData[4] + tableMeta.rowData[5] + tableMeta.rowData[6] + tableMeta.rowData[7] + tableMeta.rowData[8] + tableMeta.rowData[9]) > 0 ?
            (<Tooltip title={`Download RCD, Lifeguards and 3 Phase CSV for ${tableMeta.rowData[0]}`}>
                    <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}
                    style={{
                      color: total > 0 ? '#d32f2f' : undefined,
                      fontWeight: total > 0 ? 600 : 400
                    }}>
                      {tableMeta.rowData[4] + tableMeta.rowData[5] + tableMeta.rowData[6] + tableMeta.rowData[7] + tableMeta.rowData[8] + tableMeta.rowData[9]}
                    </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[4] + tableMeta.rowData[5] + tableMeta.rowData[6] + tableMeta.rowData[7] + tableMeta.rowData[8] + tableMeta.rowData[9]}</div>));
        },
        customHeadLabelRender: createHeaderWithTooltip('LG RCD 3PH', 'RCD, Lifeguards and 3 Phase', true)
      }
    },
    { label: 'MW', name: 'mw',
      options: {
        filter: false,
        download: false,
        sort: false,
        setCellProps: commonSetCellProps(data, lastSiteVisit),
        customBodyRender: (value, tableMeta) => {
          return (tableMeta.rowData[10] !== undefined && tableMeta.rowData[10] !== null &&
                  tableMeta.rowData[11] !== undefined && tableMeta.rowData[11] !== null &&
                  (tableMeta.rowData[10] + tableMeta.rowData[11]) > 0 ?
            (<Tooltip title={`Download Microwaves (including leakage) CSV for ${tableMeta.rowData[0]}`}>
                    <div onClick={() => onClickTagCount(tableMeta)} className={classes.tagSingleRowDownload}>
                      {tableMeta.rowData[10] + tableMeta.rowData[11]}
                    </div></Tooltip>) : (<div className={classes.tagSingleRowNoDownload}>{tableMeta.rowData[10] + tableMeta.rowData[11]}</div>));
        },
        customHeadLabelRender: createHeaderWithTooltip('MW', 'Microwaves (including leakage)')
      }},
    { label: 'one_phase_count_by_validity', name: 'one_phase_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'three_phase_count_by_validity', name: 'three_phase_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'rcd_m_count_by_validity', name: 'rcd_m_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'rcd_pb_count_by_validity', name: 'rcd_pb_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'lg_m_count_by_validity', name: 'lg_m_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'lg_pb_count_by_validity', name: 'lg_pb_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'three_phase_rcd_count_by_validity', name: 'three_phase_rcd_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'microwave_count_by_validity', name: 'microwave_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'microwave_leakage_count_by_validity', name: 'microwave_leakage_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'fire_extinguishers_count_by_validity', name: 'fire_extinguishers_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'fire_blankets_count_by_validity', name: 'fire_blankets_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'fire_hose_reels_count_by_validity', name: 'fire_hose_reels_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'first_aid_count_by_validity', name: 'first_aid_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'smoke_alarm_count_by_validity', name: 'smoke_alarm_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'medical_count_by_validity', name: 'medical_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'evse_count_by_validity', name: 'evse_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'aed_count_by_validity', name: 'aed_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'ladder_count_by_validity', name: 'ladder_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'other_count_by_validity', name: 'other_count_by_validity', options: {filter: false, download: true, display: false, sort: false} },
    { label: 'fire_extinguishers_replacement_required', name: 'fire_extinguishers_replacement_required', options: {filter: false, download: true, display: false, sort: false} },



    /*{ label: 'Action',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true,
          customBodyRenderLite: (dataIndex) => {
            return (<>
                {isCopied(dataIndex) ? null :
                  <Button className={classes.addButton} onClick={() => copyExpiry(dataIndex)}>
                      <Box mr={1} display={'flex'}>
                          <FileCopyIcon />
                      </Box>
                      Add
                  </Button>}
                  </>);
          }
        }
      },*/
      { label: '',
          name: '',
          options: {
            filter: false,
            sort: false,
            empty: true,
            customBodyRenderLite: (dataIndex) => {
              return (<>
                    <IconButton color={'inherit'}
                                aria-label={`download data csv for ${data[dataIndex].expiry}`}
                                component="span" onClick={() => downloadSelectedDataCSV(dataIndex)}>
                            <CloudDownloadIcon />
                    </IconButton>
                    </>);
            }
          }
        }
  ];





  /*useImperativeHandle(ref, () => ({
    getTotalSiteAssetsAdded(jobInstructions) {console.log('getTotalSiteAssetsAdded', jobInstructions)
        if (jobInstructions === undefined || jobInstructions === null || jobInstructions === '') {
          return 0;
        }
        var totalAssetsDue = 0;
        data.map(row => {
            if (jobInstructions.includes(`${row.assets} assets due to expire on ${row.expiry}`)) {
                totalAssetsDue += row.assets;
            }
        });
        setTotalAssetsSelected(totalAssetsDue);
        return totalAssetsDue;
    }

  }));*/

    useEffect(() => {
      // fetching data
       let mounted = true;
       const fetchData = async() => {
         //const response = await ttAPI.getSiteRetests(props.site_id);
         const response = await ttAPI.getSiteAssetsExpiryByMonthSummary(props.site_id);
         if(mounted){
            setData(response);
            var total = 0;
            response.map(row => {
                total += row.assets;
            });
            setTotalAssets(total);

            var lastJobOnSite = await ttAPI.getLastJobOnSite(props.site_id);
            setLastSiteVisit(lastJobOnSite.last_site_visit);
         }
       };
       fetchData();

       // checking screen size
       const updateFontSize = () => {
           const screenWidth = window.innerWidth;

          // Adjust font size based on screen width
          if (screenWidth <= 1280) {
            setFontSize(0.8);
            setDetailedTagCountStyle('35% 5% 60%');
          } else {
            setFontSize(0.875);
            setDetailedTagCountStyle('17% 5% 78%');
          }
        };

    // Call the updateFontSize function initially and on window resize
    updateFontSize();
    window.addEventListener('resize', updateFontSize);


       return () => {
         mounted = false;
         window.removeEventListener('resize', updateFontSize);
       }


    }, []);

    useEffect(() => {
        if (data !== undefined && data !== null && data.length > 0 && !isRowsSelectedDone) {
            const rows = [];
            data.forEach((element, index) => {
              if (isCopied(index)) {
                rows.push(index);
              }
            });
            setCurRowsSelected(rows);
            setPreRowsSelected(rows);
            setIsRowsSelectedDone(true);
        }
    }, [data, isRowsSelectedDone]);

    useEffect(() => {

        // selected at least one row
        if (curRowsSelected.length > preRowsSelected.length) {
            // if all selected
            if (curRowsSelected.length === data.length) {
                copyAllExpiry();
            }
            else {
                curRowsSelected.filter(x => preRowsSelected.indexOf(x) === -1).forEach((element) => {
                    copyExpiry(element);
                });
            }

        }
        // de-selected at least one row
        else if (preRowsSelected.length > curRowsSelected.length){
            // if all de-selected
            if (curRowsSelected.length === 0) {
                removeAllExpiry();
            }
            else {
                preRowsSelected.filter(x => curRowsSelected.indexOf(x) === -1).forEach((element) => {
                    removeExpiry(element);
                });
            }

        }
    }, [preRowsSelected, curRowsSelected]);

    const getExpiryDate = (expiry) => {
        if (!expiry) {
            return new Date(0);
        }

        const parts = expiry.split(' ');
        if (parts.length !== 2) {
            return new Date(0);
        }

        const monthMap = {
            Jan: 0, Feb: 1, Mar: 2, Apr: 3,
            May: 4, Jun: 5, Jul: 6, Aug: 7,
            Sep: 8, Oct: 9, Nov: 10, Dec: 11
        };

        return new Date(parseInt(parts[1], 10), monthMap[parts[0]], 1);
    };

    const toYearMonthValue = (expiry) => {
        const date = getExpiryDate(expiry);

        if (!date || date.getTime() === 0) {
            return null;
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');

        return `${year}-${month}`;
    };

    useEffect(() => {
        if (!data || data.length === 0 || curRowsSelected.length === 0) {
            setAssetCoverageYearMonth("1900-01");

            if (props.onAssetCoverageYearMonthChange) {
              props.onAssetCoverageYearMonthChange("1900-01");
            }

            if (props.onQualifiedTechWarningRequiredChange) {
                props.onQualifiedTechWarningRequiredChange(false);
            }
            return;
        }

        const selectedExpiryMonths = curRowsSelected
            .map(index => data[index]?.expiry)
            .filter(expiry => expiry !== undefined && expiry !== null && expiry !== '');

        if (selectedExpiryMonths.length === 0) {
            setAssetCoverageYearMonth("1900-01");

            if (props.onAssetCoverageYearMonthChange) {
              props.onAssetCoverageYearMonthChange("1900-01");
            }

            if (props.onQualifiedTechWarningRequiredChange) {
              props.onQualifiedTechWarningRequiredChange(false);
            }

            return;
        }

        const hasQualifiedTechAssets = curRowsSelected.some(index => {
          const row = data[index];

          if (!row) {
            return false;
          }

          return (
              (row.three_phase_count || 0) +
              (row.rcd_m_count || 0) +
              (row.rcd_pb_count || 0) +
              (row.lg_m_count || 0) +
              (row.lg_pb_count || 0) +
              (row.three_phase_rcd_count || 0)
            ) > 0;
        });

        if (props.onQualifiedTechWarningRequiredChange) {
            props.onQualifiedTechWarningRequiredChange(hasQualifiedTechAssets);
        }

        const latestExpiry = selectedExpiryMonths
            .slice()
            .sort((a, b) => getExpiryDate(a) - getExpiryDate(b))
            .pop();

        const latestYearMonth = latestExpiry ? toYearMonthValue(latestExpiry) : null;

        setAssetCoverageYearMonth(prev =>
            prev === latestYearMonth ? prev : latestYearMonth
        );

        if (props.onAssetCoverageYearMonthChange) {
            props.onAssetCoverageYearMonthChange(latestYearMonth || "1900-01");
        }

    }, [curRowsSelected, data]);

    const components = {
      ExpandButton: function(props) {
        return <ExpandButton {...props} />;
      }
    };

    if (data === undefined || data === null) {
      return (<><CircularProgress size={26}/></>);
    }

    const getAvatar = (id) => {
      return (<Avatar src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${id}`}/>);
    }

    const copyExpiry = (dataIndex) => {
      //isCopyClicked = true;
      //onCopyExpiry(data[dataIndex].assets, data[dataIndex].ex_month);

      var totalAssetsDue = 0;
      data.map((row, index) => {
          if (isCopied(index)) {
              totalAssetsDue += row.assets;
          }
      });
      var oldTotalAssetsDue = totalAssetsDue;
      totalAssetsDue += data[dataIndex].assets;
      setTotalAssetsSelected(totalAssetsDue);
      onCopyExpiry(data[dataIndex].assets, data[dataIndex].expiry, oldTotalAssetsDue, totalAssetsDue);
    };

    const removeExpiry = (dataIndex) => {

      var totalAssetsDue = 0;
      data.map((row, index) => {
          if (isCopied(index)) {
              totalAssetsDue += row.assets;
          }
      });
      totalAssetsDue -= data[dataIndex].assets;
      setTotalAssetsSelected(totalAssetsDue);
      //setTotalAssetsSelected(oldTotalAssetsDue);
      onRemoveExpiry(data[dataIndex].assets, data[dataIndex].expiry, totalAssetsDue);
    };

    const copyAllExpiry = () => {
      var totalAssetsDue = 0;
      data.map((row, index) => {
          totalAssetsDue += row.assets;
      });
      setTotalAssetsSelected(totalAssetsDue);
      onCopyAllExpiry(totalAssetsDue, data);
    };

    const removeAllExpiry = (dataIndex) => {
      setTotalAssetsSelected(0);
      onRemoveAllExpiry();
    };

    const isCopied = (dataIndex) => {
      //return onShowCopyExpiryButton(data[dataIndex].assets, data[dataIndex].ex_month);
      calcSelectedTotal();

      return onShowCopyExpiryButton(data[dataIndex].assets, data[dataIndex].expiry);
    };

    const addTotalSelectedToInstructions = () => {
        onAddTotalSelectedToInstructions(totalAssetsSelected);
    }

    function calcSelectedTotal() {
      var totalAssetsDue = 0;
      data.map((row, index) => {
          if (onShowCopyExpiryButton(row.assets, row.expiry)) {
              totalAssetsDue += row.assets;
          }
      });
      setTotalAssetsSelected(totalAssetsDue);
    }

    const downloadSelectedDataCSV = (dataIndex) => {
        window.open(
            `${config.clientApi}/dashboard/site_assets?id=${props.site_id}&month_expiry=${data[dataIndex].expiry}`,
            '_blank'
            );
        };

        const downloadDataCSV = () => {
        const selectedMonths = getSelectedExpiryMonths();

        if (!selectedMonths || selectedMonths.length === 0) {
            return;
        }

        const typesValue = isAllTagTypes
            ? "all"
            : (selectedTagTypes && selectedTagTypes.length > 0 ? selectedTagTypes.join('_') : "all");

        window.open(
            `${config.clientApi}/dashboard/site_assets?id=${props.site_id}&month_expiry=${selectedMonths.length === data.length ? 'all' : selectedMonths.join('_')}&types=${typesValue}`,
            '_blank'
        );
    };

    const getSelectedExpiryMonths = () => {
    if (curRowsSelected.length === data.length) {
        return data.map(row => row.expiry);
    }

    return curRowsSelected.map(index => data[index].expiry);
};

  const downloadEstimate = () => {
    const selectedMonths = getSelectedExpiryMonths();

    if (!selectedMonths || selectedMonths.length === 0) {
        return;
    }

    if (!props.site_id) {
        console.error('Missing site_id for site estimate download');
        return;
    }

    window.open(
        `${config.clientApi}/dashboard/site_estimate?site_id=${props.site_id}&months=${encodeURIComponent(selectedMonths.join('_'))}`,
        '_blank'
    );
  };

    // validity is a string like 6:10,12:0
    const convertValidities = (validity) => {
      const parts = validity.split(',');
      const formattedParts = parts.map(part => {
        const [value, count] = part.split(':');
        return `${value} months: ${count}`;
      });

      return (
        <span>{formattedParts.join(', ')}</span>
      );
    }

  return (
    <>
      <Grid container spacing={0} >
      <Grid item xs={12}>
      <Widget title={<><div className={classes.siteAssetsExpiryTitle}>
                 <div className={classes.tableTitle}>
                  Site Assets Expiry by Month
                  -
                  Last Inspected: {lastSiteVisit}
                  </div>
                &nbsp;
                </div>
             </>}
             noBodyPadding disableWidgetMenu>
      {data !== undefined && data !== null && data.length === 0 &&
        <div style={{margin:'auto 20px', paddingBottom:'20px'}}>NOT AVAILABLE - either no assets are expiring in the next year or all assets are disposed.</div>}
      {data !== undefined && data !== null && isRowsSelectedDone && <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={<><div className={classes.siteAssetsExpiryTitle}>
                     <div className={classes.tableTitle}>
                      Site Assets Expiry by Month ({totalAssetsSelected}/{totalAssets})
                      -
                      Last Inspected: {lastSiteVisit}
                      </div>
                    &nbsp;
                    </div>
                 </>}
          data={data !== undefined && data !== null && isRowsSelectedDone ? data.map(item => {
              return [
                  item.expiry,
                  item.assets,
                  item.validity,
                  item.one_phase_count,
                  item.three_phase_count,
                  item.rcd_m_count,
                  item.rcd_pb_count,
                  item.lg_m_count,
                  item.lg_pb_count,
                  item.three_phase_rcd_count,
                  item.microwave_count,
                  item.microwave_leakage_count,
                  item.fire_extinguishers,
                  item.fire_blankets,
                  item.fire_hose_reels,
                  item.smoke_alarm,
                  item.first_aid_count,
                  item.medical_count,
                  item.evse_count,
                  item.aed_count,
                  item.ladder_count,
                  item.other_count,
                  item.lg_m_count,
                  item.microwave_count,
                  item.one_phase_count_by_validity,
                  item.three_phase_count_by_validity,
                  item.rcd_m_count_by_validity,
                  item.rcd_pb_count_by_validity,
                  item.lg_m_count_by_validity,
                  item.lg_pb_count_by_validity,
                  item.three_phase_rcd_count_by_validity,
                  item.microwave_count_by_validity,
                  item.microwave_leakage_count_by_validity,
                  item.fire_extinguishers_count_by_validity,
                  item.fire_blankets_count_by_validity,
                  item.fire_hose_reels_count_by_validity,
                  item.smoke_alarm_count_by_validity,
                  item.first_aid_count_by_validity,
                  item.medical_count_by_validity,
                  item.evse_count_by_validity,
                  item.aed_count_by_validity,
                  item.ladder_count_by_validity,
                  item.other_count_by_validity,
                  item.fire_extinguishers_replacement_required
              ]
          }) : []}
          columns={columns}
          options={{
            filterType: "multiselect",
            responsive: 'standard',
            print: false,
            viewColumns: false,
            selectableRows: 'multiple',
            selectableRowsOnClick: false,
            search: false,
            download: false,
            filter: false,
            pagination: false,
            rowsSelected: curRowsSelected,
            textLabels: {
              selectedRows: {
                text: "site expiry group(s) selected",
            }},
            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                  return (<></>);
            },
            /*customRowRender: (rowData, dataIndex, rowIndex) => {
                   return  (
                      <TableRow key={rowData[0]} id={rowIndex}>
                          <TableCell>
                               <div>{rowData[0]}</div>
                          </TableCell>
                          <TableCell}>
                               <div>{rowData[1]}</div>
                          </TableCell>
                          <TableCell}>
                               <div>{rowData[2]}</div>
                          </TableCell>
                          <TableCell}>
                               <div>{rowData[12]}</div>
                          </TableCell>
                          <TableCell}>
                               <div>{rowData[16]}</div>
                          </TableCell>
                          <TableCell>
                               <div>{rowData[17]}</div>
                          </TableCell>
                          <TableCell>
                               <div>{rowData[18]}</div>
                          </TableCell>
                          <TableCell>
                               <div>{rowData[19]}</div>
                          </TableCell>
                          <TableCell>
                               <div>{rowData[4] + rowData[5] + rowData[6] + rowData[7] + rowData[8] + rowData[9]}</div>
                          </TableCell>
                          <TableCell>
                               <div>{rowData[10] + rowData[11]}</div>
                          </TableCell>
                      </TableRow>)},*/
                      customFooter: () => {
                        const hasSelection = curRowsSelected.length > 0;
                        const selectedMonths = getSelectedExpiryMonths();

                        return (
                          <TableFooter>
                            <TableRow className={classes.footerRow}>
                              <TableCell colSpan={columns.length + 1} className={classes.footerFullCell}>
                              <div className={classes.footerBar}>
                                {/* TOP ROW */}
                                <div className={classes.footerTopRow}>

                                      <div className={classes.footerLeft}>
                                        <Tooltip title="Calculate Selected Total">
                                          <div className={classes.calculateDiv}>
                                            <Link onClick={addTotalSelectedToInstructions} className={classes.calculate}>
                                              Calculate
                                            </Link>
                                            &nbsp;&nbsp;&nbsp;
                                            {totalAssetsSelected} of {totalAssets} Selected
                                          </div>
                                        </Tooltip>
                                      </div>

                                      <div className={classes.footerRightTop}>
                                        <FormControlLabel
                                          className={classes.footerSwitchLabel}
                                          control={
                                            <Switch
                                              checked={isAllTagTypes}
                                              onChange={(e) => setIsAllTagTypes(e.target.checked)}
                                              color="primary"
                                            />
                                          }
                                          label="Download ALL Tag Types"
                                        />
                                      </div>

                                    </div>

                                {/* BOTTOM ROW */}
                                <div className={classes.footerBottomRow}>
                                <Tooltip title="Generate estimate for multiple sites">
                                  <span>
                                  <Button
                                      variant="contained"
                                      color="primary"
                                      startIcon={<LayersIcon />}
                                      onClick={() => setOpenMultiSiteEstimate(true)}
                                      >
                                      Multi-Site Estimate
                                      </Button>
                                  </span>
                                  </Tooltip>

                                  <Tooltip title={hasSelection ? `Generate estimate for ${selectedMonths.join(', ')}` : 'Select at least one expiry group'}>
                                    <span>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      startIcon={<DescriptionIcon />}
                                      disabled={!hasSelection}
                                      onClick={() => setOpenCustomerNotesReview(true)}
                                      >
                                      Generate Estimate
                                      </Button>
                                    </span>
                                  </Tooltip>

                                  <Tooltip title="Download selected data CSV">
                                    <span>
                                      <IconButton
                                        color="primary"
                                        aria-label="download data csv"
                                        onClick={downloadDataCSV}
                                        disabled={!hasSelection}
                                      >
                                        <CloudDownloadIcon />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                </div>

                                </div>
                              </TableCell>
                            </TableRow>
                          </TableFooter>
                        );
                      },
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {console.log('onRowSelectionChange');
              setPreRowsSelected(curRowsSelected);
              setCurRowsSelected(rowsSelected);

            },
            expandableRows: true,
            expandableRowsOnClick: true,
            rowsExpanded: false,
            renderExpandableRow:  (rowData, rowMeta) => {
              return (
                <TableRow>
                  <TableCell colSpan={19} className={classes.expandableTagRow}>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>1 Phase:</span> </div>
                      <div className={classes.gridCol}>{ rowData[3]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[24])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>3 Phase:</span> </div>
                      <div className={classes.gridCol}>{ rowData[4]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[25])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>RCD Measured:</span> </div>
                      <div className={classes.gridCol}>{ rowData[5]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[26])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>RCD Push Button:</span> </div>
                      <div className={classes.gridCol}>{ rowData[6]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[27])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>LG6 Measured:</span> </div>
                      <div className={classes.gridCol}>{ rowData[7]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[28])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>LG Push Button:</span> </div>
                      <div className={classes.gridCol}>{ rowData[8]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[29])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>3 Phase RCD:</span> </div>
                      <div className={classes.gridCol}>{ rowData[9]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[30])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Microwave:</span> </div>
                      <div className={classes.gridCol}>{ rowData[10]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[31])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Microwave Leakage:</span> </div>
                      <div className={classes.gridCol}>{ rowData[11]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[32])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Fire Extinguisher:</span> </div>
                      <div className={classes.gridCol}>{ rowData[12].props.children}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[33])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Fire Blankets:</span> </div>
                      <div className={classes.gridCol}>{ rowData[13]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[34])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Fire Hose Reels:</span> </div>
                      <div className={classes.gridCol}>{ rowData[14]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[35])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Smoke Alarm:</span> </div>
                      <div className={classes.gridCol}>{ rowData[15]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[36])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>First Aid:</span> </div>
                      <div className={classes.gridCol}>{ rowData[16].props.children}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[37])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Medical:</span> </div>
                      <div className={classes.gridCol}>{ rowData[17].props.children}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[38])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>EVSE:</span> </div>
                      <div className={classes.gridCol}>{ rowData[18].props.children}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[39])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>AED:</span> </div>
                      <div className={classes.gridCol}>{ rowData[19].props.children}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[40])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Ladder:</span> </div>
                      <div className={classes.gridCol}>{ rowData[20]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[41])}</div>
                    </div>
                    <div className={classes.colWrapper} style={{ gridTemplateColumns: `${detailedTagCountStyle}`}}>
                      <div className={classes.gridCol}><span className={classes.bold}>Other:</span> </div>
                      <div className={classes.gridCol}>{ rowData[21]}</div>
                      <div className={classes.gridCol}>{convertValidities(rowData[42])}</div>
                    </div>
                  </TableCell>
                </TableRow>
              )
            }

            /*expandableRows: true,
            expandableRowsOnClick: true,
            expandableRowsHeader: true,
            rowsExpanded: rowsExpanded,//[0, 1],
            renderExpandableRow:  (rowData, rowMeta) => {
                const colSpan = 3;
              return (
                <TableRow>
                  <TableCell colSpan={colSpan}>
                    <div className={classes.twoColWrapper}>
                      <div className={classes.gridCol}><span className={classes.bold}>Last Job ID:</span> </div>
                      <div className={classes.gridCol}>{ rowData[6]}</div>
                      <div><span className={classes.bold}>Last Instructions:</span></div>
                      <div className={classes.gridCol}>{ rowData[5]}</div>
                      <div><span className={classes.bold}>Last Techs worked on site:</span></div>
                      <div className={classes.gridCol}>
                        {rowData[7] !== null && rowData[7] !== undefined && rowData[7].map((value) => {
                          return (
                          <Fragment key={value.id}>
                              <div className={classes.workerRow}>
                                <Chip label={value.name}
                                      className={classes.chip}
                                      variant={value.is_leader ? 'default' : 'outlined'}
                                      avatar={getAvatar(`${value.id}`)}/>
                                <span>{value.notes}</span>
                              </div>
                          </Fragment>
                        );
                        })}
                      </div>
                      <div className={classes.gridCol}><span className={classes.bold}>Last total hours spent on site:</span> </div>
                      <div className={classes.gridCol}>{rowData[8] === null ? 'N/A' : `${rowData[8]}`}</div>
                    </div>
                  </TableCell>
                </TableRow>
              )
            },
            isRowExpandable: (dataIndex, expandedRows) => {
              if (isCopyClicked) {
                isCopyClicked = false;
                return false;
              }
              return true;
            },

            onTableChange: (action, tableState) => {
                    switch (action) {
                      case "rowExpansionChange":
                        var rowsExpanded = tableState.expandedRows.data.map(
                          item => item.index
                        );

                        console.dir(rowsExpanded);

                        setRowsExpanded(rowsExpanded);

                        break;
                    }
                  }*/

          }}
          components={components}
        />
        </MuiThemeProvider>}
        </Widget>
      </Grid>
      </Grid>

      <CustomerNotesReviewDialog
        open={openCustomerNotesReview}
        onClose={() => setOpenCustomerNotesReview(false)}
        onConfirm={() => {
          setOpenCustomerNotesReview(false);
          downloadEstimate();
        }}
        notes={props.customer_notes}
        bookingInstructions={props.booking_instructions}
      />

      <MultiSiteEstimateDialog
        open={openMultiSiteEstimate}
        onClose={() => setOpenMultiSiteEstimate(false)}
        siteId={props.site_id}
        customerId={props.customer_id}
        customerNotes={props.customer_notes}
        bookingInstructions={props.booking_instructions}
      />
    </>
  );
});

export default SiteRetests;
